var bind = require('function-bind');

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/has/src/index.js
// module id = 273
// module chunks = 168707334958949